module.exports = "<div>\n  <my-table my-data=\"myCommande\"\n    my-nature=\"'commande'\"\n    enable-badges=\"true\">\n  </my-table>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/commande/directives/display/myCommande.html
// module id = 1171
// module chunks = 0